import { ClickAnalyticsPlugin, IClickAnalyticsConfiguration } from '@microsoft/applicationinsights-clickanalytics-js'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { createBrowserHistory } from 'history'

import { currentEnv } from '@/env/vars.ts'

const browserHistory = createBrowserHistory()
export const reactPlugin = new ReactPlugin()
const clickPluginInstance = new ClickAnalyticsPlugin()
const clickPluginConfig: IClickAnalyticsConfiguration = {
    autoCapture: true,
}
export const appInsights = new ApplicationInsights({
    config: {
        connectionString: currentEnv.appInsightsConnectionString,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
            [clickPluginInstance.identifier]: clickPluginConfig,
        },
    },
})

export function formatEventName(name: string) {
    return {
        name: name
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-zA-Z0-9-]/g, ''),
    }
}

export function track(eventName: string) {
    const n = formatEventName(eventName)
    appInsights.trackEvent(n)
    console.debug(`Tracking Event: ${n.name}`)
}
